let resizeCaptions = () => {
	$('.article-caption').each(function(index, el) {
		$(el).width($(el).siblings('img').width()).css('opacity', '1');
	});
}
$(window).resize(resizeCaptions).trigger('resize');